import { StyledInput, StyledInputGroup, StyledTextArea } from './styles';

const Input = (props) => <StyledInput {...props} />;

Input.Group = StyledInputGroup;
Input.TextArea = StyledTextArea;

export default Input;
